import axios from 'axios'

import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { errorResponseInterceptor } from '../../../interceptors/http-interceptor/errorResponse'
import { requestInterceptor } from '../../../interceptors/http-interceptor/request'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'

export const configureUnauthenticatedAPI = (url: string) => {
  const instance = axios.create({ baseURL: url })
  instance.interceptors.request.use(requestInterceptor, errorRequestInterceptor)
  instance.interceptors.response.use(
    responseInterceptor,
    errorResponseInterceptor
  )
  return instance
}
